import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AdminLayoutComponent } from './layouts/admin/admin-layout.component';
import { LoginComponent } from './login/login.component';

import { BancoAddComponent } from './components/cobros/banco-add/banco-add.component';
import { BancoEditComponent } from './components/cobros/banco-edit/banco-edit.component';
import { BancoListComponent } from './components/cobros/banco-list/banco-list.component';
import { FormaPagoAddComponent } from './components/cobros/forma-pago-add/forma-pago-add.component';
import { FormaPagoEditComponent } from './components/cobros/forma-pago-edit/forma-pago-edit.component';
import { FormaPagoListComponent } from './components/cobros/forma-pago-list/forma-pago-list.component';
import { ArqueoCajaAddComponent } from './components/cobros/arqueo-caja-add/arqueo-caja-add.component';
import { CobroListComponent } from './components/cobros/cobro-list/cobro-list.component';
import { CobroAddComponent } from './components/cobros/cobro-add/cobro-add.component';

import { AuthGuard } from './guards/auth.guard';
import { PermisoGuard } from './guards/permiso.guard';
import { LockedLoginComponent } from './locked-login/locked-login.component';
import { DesktopComponent } from './components/desktop/desktop/desktop.component';
import { LoginPrincipalComponent } from './components/login/login-principal/login-principal.component';
import { LandingPageLoginComponent } from './components/login/landing-page-login/landing-page-login.component';
import { RegistroComponent } from './components/login/registro/registro.component';
import { MenuComponent } from './components/desktop/menu/menu.component';
import { SubmenuComponent } from './components/desktop/submenu/submenu.component';
import { CobroGrupoComponent } from './components/cobros/cobro-grupo/cobro-grupo.component';
import { NewLoginComponent } from './components/login/new-login/new-login.component';
import { NewRegistroComponent } from './components/login/new-registro/new-registro.component';
import { CruceNotaCreditoComponent } from './components/cobros/cruce-nota-credito/cruce-nota-credito.component';

const appRoutes: Routes = [
	//{ path: 'login/:usuario/:token/:expired_at', component: LoginComponent },
	// { path: 'login', component: LoginPrincipalComponent },
	//{ path: 'registro', component: RegistroComponent },
	{ path: 'login', component: NewLoginComponent },
	{ path: 'registro', component: NewRegistroComponent },
	//{ path: 'login', component: LandingPageLoginComponent },
	{ path: 'locked-login', component: LockedLoginComponent },
	{ path: '', component: AdminLayoutComponent, canActivate: [AuthGuard], children: [
		{ path: 'desktop', component: DesktopComponent },
		{ path: 'menu', component: MenuComponent },
		{ path: 'submenu', component: SubmenuComponent },

		{ path: 'ventas', loadChildren: './components/ventas/ventas.module#VentasModule' },
		{ path: 'compras', loadChildren: './components/compras/compras.module#ComprasModule' },
		{ path: 'inventario', loadChildren: './components/inventario/inventario.module#InventarioModule' },
		{ path: 'seguridad', loadChildren: './components/seguridad/seguridad.module#SeguridadModule' },
		{ path: 'general', loadChildren: './components/general/general.module#GeneralModule' },
		{ path: 'configuracion', loadChildren: './components/configuracion/configuracion.module#ConfiguracionModule' },
		{ path: 'ecommerce', loadChildren: './components/ecommerce/ecommerce.module#EcommerceModule' },
		{ path: 'consultacompras', loadChildren: './components/consulta_compras/consulta-compras.module#ConsultaComprasModule' },
		{ path: 'consultaventas', loadChildren: './components/consulta_ventas/consulta-ventas.module#ConsultaVentasModule' },
		{ path: 'restaurante', loadChildren: './components/restaurante/restaurante.module#RestauranteModule' },
		{ path: 'contabilidad', loadChildren: './components/contabilidad/contabilidad.module#ContabilidadModule' },
		{ path: 'hotel', loadChildren: './components/hotel/hotel.module#HotelModule' },
		{ path: 'sri', loadChildren: './components/tributacion-sri/tributacion-sri.module#TributacionSriModule' },
		{ path: 'activosfijos', loadChildren: './components/activos-fijos/activos-fijos.module#ActivosFijosModule' },
		{ path: 'bancos', loadChildren: './components/bancos/bancos.module#BancosModule' },
		{ path: 'marketplace', loadChildren: './components/marketplace/marketplace.module#MarketplaceModule' },

		////////

		{ path: 'cobro/bancos/crear', component: BancoAddComponent },
		{ path: 'cobro/bancos-edit', component: BancoEditComponent },
		{ path: 'cobro/bancos-list', component: BancoListComponent },
		{ path: 'cobro/forma-pago/crear', component: FormaPagoAddComponent },
		{ path: 'cobro/forma-pago-edit', component: FormaPagoEditComponent },
		{ path: 'cobro/forma-pago-list', component: FormaPagoListComponent },
		{ path: 'cobro/arqueo-caja-crear', component: ArqueoCajaAddComponent },
		{ path: 'cobro/cobro-list', component: CobroListComponent },
		{ path: 'cobro/cobro/:tipo/:id', component: CobroAddComponent },
		{ path: 'cobro/cobro-grupo', component: CobroGrupoComponent },
		{ path: 'nota-credito/cruce', component: CruceNotaCreditoComponent },
	] },
];

export const appRoutingProviders: any[] = [];
export const routing: ModuleWithProviders = RouterModule.forRoot(appRoutes, { useHash: true });


// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/app.routing.ts